/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `50000` - Mini 50000
 * * `100000` - Mini 100000
 */
export enum AmountEnum {
  '_50000' = 50000,
  '_100000' = 100000,
}
